var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1249 30.5625C15.6782 30.5625 16.9374 29.3033 16.9374 27.75C16.9374 26.1967 15.6782 24.9375 14.1249 24.9375C12.5716 24.9375 11.3124 26.1967 11.3124 27.75C11.3124 29.3033 12.5716 30.5625 14.1249 30.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5624 30.5625C25.1157 30.5625 26.3749 29.3033 26.3749 27.75C26.3749 26.1967 25.1157 24.9375 23.5624 24.9375C22.0091 24.9375 20.7499 26.1967 20.7499 27.75C20.7499 29.3033 22.0091 30.5625 23.5624 30.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.937495 4.31255H4.84703L9.37313 20.157L9.01814 20.867C8.08339 22.7345 9.44032 24.9374 11.534 24.9374H27.3123C27.8305 24.9374 28.2498 24.5181 28.2498 23.9999C28.2498 23.4818 27.8305 23.0624 27.3123 23.0624H11.534C10.8378 23.0624 10.3828 22.3294 10.6954 21.7056L10.9545 21.1875H27.3123C27.7307 21.1875 28.0988 20.9101 28.2141 20.5072L31.9641 7.38228C32.0447 7.09941 31.9879 6.79541 31.8113 6.56016C31.6336 6.32579 31.3563 6.18754 31.0624 6.18754H7.33264L6.45559 3.11775C6.34021 2.71494 5.97222 2.4375 5.55378 2.4375H0.937495C0.41931 2.4375 0 2.85681 0 3.37499C0 3.89318 0.41931 4.31255 0.937495 4.31255Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.6689c66403c9a8bda6206021042aae17.svg";
export { ForwardRef as ReactComponent };